export default "__VITE_ASSET__3195ISbx__"